export default __webpack_public_path__ + "static/media/hero-c.34aeb841.jpg";